import startCase from 'lodash/startCase';

const labelText = attrName => startCase(attrName.split('.').pop());

export default labelText;
